module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n            +\n       ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', [_vm._v("día")]), _vm._v(" "), _c('th', [_vm._v("semana")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Inicial")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Final")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.kilometraje.results), function(kilometraje) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(_vm._f("formatDate2")(kilometraje.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.user_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.dia))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.semana))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_inicial))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_final))])])
  }), 0)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Kilometraje ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Kilometraje Inicial:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_inicial),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_inicial", $$v)
      },
      expression: "akilometraje.kilometraje_inicial"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Kilometraje Final:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_final),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_final", $$v)
      },
      expression: "akilometraje.kilometraje_final"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "día:"
    },
    model: {
      value: (_vm.akilometraje.dia),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "dia", $$v)
      },
      expression: "akilometraje.dia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Semana:"
    },
    model: {
      value: (_vm.akilometraje.semana),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "semana", $$v)
      },
      expression: "akilometraje.semana"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.editarkilometraje
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e94eceb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KilometrajeVendedor.vue
// module id = 454
// module chunks = 1